import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ChipModule } from 'primeng/chip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MultiSelectModule } from 'primeng/multiselect';
import { CheckboxModule } from 'primeng/checkbox';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { Column, Project } from '../../project.interface';
import { RolesService } from '../../../../../../shared/services/roles.service';
import { Role } from '../../../../../../shared/interfaces/roles.interface';
import { ReviewerService } from '../../../../../../shared/services/reviewers.service';
import { Reviewer } from '../../../../../../shared/interfaces/reviewer.interface';
import { OfferConfirmationModalComponent } from './modals/offer-confirmation-modal/offer-confirmation-modal.component';
import { DialogService, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { OfferService } from '../../../../../../shared/services/offers.service';
import { Offers } from '../../../../../../shared/interfaces/offers.interface';
import { TalentPoolService } from '../../../../../../shared/services/talent-pool.service';
import { TalentPool } from '../../../../../../shared/interfaces/talent-pool.interface';
import { TalentpoolModalComponent } from './modals/talent-pool-modal/talent-pool-modal.component';
import { constants } from '../../../../../../shared/constants/constants';
import { ToastService } from '../../../../../../shared/services/toast.service';
import { ProjectService } from '../../../../../../shared/services/project.service';
import { RatingModule } from 'primeng/rating';
import { ReviewerDetailDialogService } from '../../../../../../shared/services/reviewer-detail-dialog.service';
import { TooltipModule } from 'primeng/tooltip';
import { RoleService } from '../../../../../../shared/services/role.service';
import { ConfirmationDialogService } from '../../../../../../shared/services/confirmation-dialog.service';
import { BadgeModule } from 'primeng/badge';
import { PayRateSelectorModalComponent } from './modals/pay-rate-selector-modal/pay-rate-selector-modal.component';
import { ConfigurationService } from '../../../../../../shared/services/configuration.service';
import { UserService } from '../../../../../../shared/services/user.service';
import { FirmService } from '../../../../../../shared/services/firm.service';
import { lastValueFrom } from 'rxjs';
import { UserClientVm } from '../../../../../../store/user/user.interface';
import { PipesModule } from '../../../../../../shared/pipes/pipes.module';
import { HelperService } from '../../../../../../shared/services/helper.service';
import { MultiSelectSelectorModalComponent } from './modals/multi-select-selector-modal/multi-select-modal.component';

@Component({
  selector: 'app-project-offers',
  standalone: true,
  imports: [
    DragDropModule,
    ChipModule,
    TabViewModule,
    DropdownModule,
    CalendarModule,
    CheckboxModule,
    InputTextareaModule,
    FormsModule,
    RatingModule,
    RadioButtonModule,
    FloatLabelModule,
    InputTextModule,
    InputSwitchModule,
    MultiSelectModule,
    CommonModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    IconFieldModule,
    InputIconModule,
    InputNumberModule,
    OverlayPanelModule,
    DialogModule,
    TableModule,
    DynamicDialogModule,
    TooltipModule,
    BadgeModule,
    PipesModule
  ],
  providers: [DialogService],
  templateUrl: './offers.component.html',
  styleUrl: './offers.component.scss'
})
export class OffersComponent implements OnInit, OnDestroy {

  roles: Array<Role> = [];
  selectedRole: Role | null = null;
  updatedRole: Role | null = null;
  reviewers: Array<Reviewer> = [];
  autogeneratedReviewers: Array<Reviewer> = [];
  selectedReviewers: Array<Reviewer> = [];
  shortlistedReviewers: Array<Reviewer> = [];
  selectedShortlistedReviewers: Array<Reviewer> = [];
  selectedOfferedQueueReviewers: Array<Reviewer> = [];
  sendOfferRef: DynamicDialogRef | undefined;
  sendBulkOfferRef: DynamicDialogRef | undefined;
  resumeOfferRef: DynamicDialogRef | undefined;
  pauseOfferRef: DynamicDialogRef | undefined;
  talentPoolRef: DynamicDialogRef | undefined;
  payRateSelectorRef: DynamicDialogRef | undefined;
  rankingSelectorRef: DynamicDialogRef | undefined;
  locationSelectorRef: DynamicDialogRef | undefined;
  loadingReviewers: boolean = true;
  continueSendingOfferCheckBox:boolean = false;
  cols: Column[] = [
    { field: 'name', header: 'Name' },
    { field: 'favorite', header: ' '},
    { field: 'rating', header: 'Rating' },
    { field: 'together', header: 'Projects Together' },
    { field: 'actions', header: 'Action' },
  ];
  
  fixedCols = [
    ...this.cols
  ];
  categories: any[] = [
    { name: 'None', key: '' },
    { name: 'Worked Together', key: 'workedTogetherReviewers' },
    { name: 'In House', key: 'occupied' },
    { name: 'Restricted', key: 'restrictedReviewers' },
    { name: 'Screened Out', key: 'conflicted' },
    { name: 'Rejected', key: 'declined' },
    { name: 'Previously Assigned ', key: 'firedQuit' },
    { name: 'Talent Pool', key: 'talentPool' },
    { name: 'Location', key: 'location' }
  ];

  minPayRateValue: number = 1;
  maxPayRateValue: number = 10;

  sortOptions: any[] = [
    { name: 'Smart Sort', key: '' },
    { name: 'Recently logged in', key: 'Activity' },
    { name: 'Date Invited', key: 'Date Verified' },
    { name: 'Projects Together', key: 'Projects Together' },
    { name: 'Star Rating', key: 'Star Rating' },
    { name: 'Recently Available', key: 'Recently Available' }
  ];
  selectedSortOption: Array<any> = [this.sortOptions[0]];
  selectedSortOrder: Boolean = false;
  roleRateType = constants.roleRateType;

  selectedFilter: any = this.categories[0];

  talentPools: Array<TalentPool> = [];
  category!: string;
  @Input()
  id: string | null = null;
  @Input()
  project: Project | null = null;
  @Input() isDefaultSelectedRole = false;
  @Output()
  updateProjectState: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  changeTab: EventEmitter<number> = new EventEmitter<number>();

  selectedPoolIds: Array<string> = [];
  isFullTimePermanantProject = false;
  isUnPublishedProject = false;

  initialPosition = 0;
  showPositionSaveButton = false;

  initialHour = 0;
  showHourSaveButton = false;

  initialOvertime = 0;
  showOvertimeSaveButton = false;


  savingHourlyRate = false;

  searchDebounce: any = null;

  searchShortListedDebounce: any = null;
  searchOfferDebounce: any = null;

  totalReviewersCount: number = 0;

  searchValue = '';
  searchShortListed = '';
  searchOfferValue = '';
  selectedType = 'primary';

  // Multi-filter stacking
  readonly STACKABLE_FILTER_KEYS = new Set([
    constants.offerSenderFiltersKeys.TALENT_POOL,
    constants.offerSenderFiltersKeys.PAY_RATE,
    constants.offerSenderFiltersKeys.RANKING,
    constants.offerSenderFiltersKeys.LOCATION,
  ]);
  stackedFilters = new Map<string, { name: string; poolIds?: string[]; minVal?: number; maxVal?: number; payRateType?: string; type?: any }>();

  get stackedFiltersArray() {
    return Array.from(this.stackedFilters.entries()).map(([key, val]) => ({ key, ...val }));
  }

  showReviewerSearchError = false;

  lastPage = false;
  pagination = constants.pagination.offers;

  // Named tab indexes for better readability
  readonly TAB_INDEXES = {
    SELECT_CANDIDATES: 0,
    OFFERS_QUEUE: 1,
    OFFER_QUEUE_LOGS: 2
  } as const;

  readonly OFFER_QUEUE_TAB_INDEXES = {
    OFFER_QUEUED_LIST: 0,
    SHORTLISTED_CANDIDATES: 1
  } as const;

  activeTabIndex: number = this.TAB_INDEXES.SELECT_CANDIDATES;
  offerQueueActiveTabIndex: number = this.OFFER_QUEUE_TAB_INDEXES.OFFER_QUEUED_LIST;

  showResumeButton = false;

  offersReviewersCount = 0;
 // Add these new loading properties for the loaders in tab headers
  loadingShortlistedReviewers: boolean = false;
  loadingOfferedQueueReviewers: boolean = false;

  shortListedReviewersCount = 0;
  columnConfigs: { [key: string]: Column[] } = {
    workedTogetherReviewers: [{ field: 'lastAssigned', header: 'Last Assigned' }],
    occupied: [
      { field: 'currentProject', header: 'Current Project' },
    ],
    availableSoon: [
      { field: 'availableSoon', header: 'Available Soon' },
    ],
    conflicted: [{ field: 'conflicts', header: 'Screening Questions'}],
    firedQuit: [{field: 'firedQuit', header: 'Previously Assigned'}]
  };
  userObject!: UserClientVm;
  isPwcEnabled = false;
  firm!: any;
  availableSoonDays: number = 15;
  showAvailableSoonModal: boolean = false;
  private _pendingAvailableSoonCategory: any = null;
  offerQueueLogs: Array<{ reviewer: any, status: string, offerSentAt?: string, error?: string }> = [];
  loadingOfferQueueLogs = false;
  constructor(
    private rolesService: RolesService,
    private reviewerService: ReviewerService,
    private dialogService: DialogService,
    private offerService: OfferService,
    private talentPoolService: TalentPoolService,
    private projectService: ProjectService,
    private toast: ToastService,
    private reviewerDetailDialogService:ReviewerDetailDialogService,
    private roleService: RoleService,
    private confirmationDialogService: ConfirmationDialogService,
    private configurationService: ConfigurationService,
    private userService: UserService,
    public helperService: HelperService
  ) {
    this.isPwcEnabled = this.configurationService.getPwcFlag();
  }

  async ngOnInit() {

    if(this.isPwcEnabled){
      this.categories.push(
        { name: 'Pay Rate', key: 'payRate' },
        { name: 'Ranking', key: 'ranking' },
        { name: 'Available Soon', key: 'availableSoon' },
      )
    }

    this.userObject = this.userService.getSessionUser();
    this.firm = this.userObject.firm;
    await this.getRolesByProjectId();
    this.setDefaultRole();
    this.initializeProjectAndRole();
    await this.getReviewersByProjectAndRoleId();
    await this.getTalentPools();

  }

  async getTalentPools(): Promise<void> {
    this.talentPools = await this.talentPoolService.getPoolsList();
  }

  async getRolesByProjectId(): Promise<void> {
    this.roles = await this.rolesService.getActiveRolesByProjectId(this.id || '');
  }

  async onRoleChange(): Promise<void> {
    this.onInputChange();

  }

    // Update onInputChange to reset loading states
  async onInputChange(): Promise<void> {
    // Reset loading states when changing roles
    this.loadingReviewers = true;
    this.loadingShortlistedReviewers = false;
    this.loadingOfferedQueueReviewers = false;
    
    this.initializeProjectAndRole();
    if(this.activeTabIndex === this.TAB_INDEXES.OFFERS_QUEUE){
      await this.initializeOfferQueueReviewers();
      if(this.selectedOfferedQueueReviewers.length > 0){
        this.offerQueueActiveTabIndex = this.OFFER_QUEUE_TAB_INDEXES.OFFER_QUEUED_LIST;
      }else{
        this.offerQueueActiveTabIndex = this.OFFER_QUEUE_TAB_INDEXES.SHORTLISTED_CANDIDATES;
      }
      await this.initializeShortListedReviewer();
    }
    
    await this.getRoleByProjectAndRoleID();
    await this.getReviewersByProjectAndRoleId();
  
    this.initializeResumeButton();
    this.continueSendingOfferCheckBox = false;
  }

  setDefaultRole(): void {
    if(this.isDefaultSelectedRole ) {
      this.selectedRole = this.roles.length ? this.roles[0] : null;
    }
    else {
      this.selectRoleForOffer(this.roleService.role);
    }
  }

  initializeProjectAndRole() {
    this.isUnPublishedProject = constants.projectStatus.created === this.project?.status;
    if (this.selectedRole) {
      this.isFullTimePermanantProject = this.selectedRole.project?.workSchedule?.duration === 'Permanent/Full-Time';
      this.selectedRole.disableOvertime = false;
      this.selectedRole.positions = this.selectedRole.positions ? this.selectedRole.positions : 0;
      this.initialPosition = this.selectedRole.positions;
      this.selectedRole.positionsMin = this.selectedRole.positions;
      this.selectedRole.hourlyRate = this.selectedRole.hourlyRate ? this.selectedRole.hourlyRate : 0;
      this.initialHour = this.selectedRole.hourlyRate;
      this.selectedRole.overtimeSelected = false;
      if (this.selectedRole.overTime && this.selectedRole.overTime > 0) {
        this.selectedRole.overtimeSelected = true;
        this.selectedRole.disableOvertime = !this.isUnPublishedProject;
      }
      this.selectedRole.overTime = this.selectedRole.overTime ? this.selectedRole.overTime : 0;
      this.initialOvertime = this.selectedRole.overTime || 0;
      if (this.isUnPublishedProject) {
        this.setUnpublishedProjectData();
      } else {
        this.setPublishedProjectData();
      }
    }
  }

  setUnpublishedProjectData(){
    if(this.selectedRole){
      this.selectedRole.occupiedPositions = 0;
      this.selectedRole.hourlyRateMin = 0;
      this.selectedRole.hourlyRateSaved = 0;
      this.selectedRole.overTimeMin = this.offerService.calculateOvertime(this.selectedRole) || 0;
      this.selectedRole.overTimeSaved = 0;
    }
  }

  setPublishedProjectData(){
    if(this.selectedRole){
      this.selectedRole.occupiedPositions = (this.selectedRole.occupiedPositions || 0);
      this.selectedRole.hourlyRateMin = this.selectedRole.offerSent ? this.selectedRole.hourlyRate : 0;
      this.selectedRole.hourlyRateSaved = this.selectedRole.hourlyRate;
      this.selectedRole.overTimeMin = this.selectedRole.offerSent ? this.selectedRole.overTime : this.offerService.calculateOvertime(this.selectedRole);
      this.selectedRole.overTimeSaved = this.selectedRole.overTime;
      this.selectedRole.disableOvertime = (this.selectedRole.overTime > 0 && this.selectedRole.offerSent);
    }
  }

  onChangePosition(): void {
    if (!this.selectedRole) {
      return;
    }
    if (this.selectedRole.positions !== this.initialPosition) {
      this.showPositionSaveButton = true;
    } else {
      this.showPositionSaveButton = false;
    }
  }

  onChangeHour(): void {
    if (!this.selectedRole) {
      return;
    }
    if (this.selectedRole.hourlyRate !== this.initialHour) {
      this.showHourSaveButton = true;
    } else {
      this.showHourSaveButton = false;
    }
  }

  toggleContinueSendingOfferOnRole(event:any): void {
    if(this.selectedRole){
      this.selectedRole.continueSendingOffers = this.continueSendingOfferCheckBox;
    }

    if(this.selectedShortlistedReviewers.length === 0 && this.continueSendingOfferCheckBox === true){

      this.openBulkSendOfferModal();
    }
  }

  onChangeOvertime(): void {
    if (!this.selectedRole) {
      return;
    }
    if (this.selectedRole.overtimeSelected && this.selectedRole.overTime > 0 && this.selectedRole.overTime !== this.initialOvertime) {
      this.showOvertimeSaveButton = true;
    } else {
      this.showOvertimeSaveButton = false;
    }
  }

  async updatePositions(positions: number): Promise<any> {
    if (!this.selectedRole) {
      return;
    }
    if (!positions || positions < this.selectedRole?.occupiedPositions) {
      this.toast.showError(constants.select.error.minimumDesiredFreelancer);
      return;
    }
    const data = { positions };
    await this.projectService.updateProjectRole(this.id || '', this.selectedRole._id, data);
    this.selectedRole.positionsMin = positions;
    this.initialPosition = positions;
    this.showPositionSaveButton = false;
    await this.onInputChange();
  }


  async updateHourlyRate(hourlyRate: number, overtime: number, payType: string): Promise<void> {
    if (!this.selectedRole) {
      return;
    }
    if (!hourlyRate) {
      this.toast.showError(constants.select.error.minimumHourlyRate);
      return;
    }
    if (this.selectedRole.offerSent && hourlyRate < this.selectedRole.hourlyRateSaved) {
      this.toast.showError('Hourly rate cannot be reduced once offers are sent');
      return;
    }
    const data: any = { hourlyRate: hourlyRate.toFixed(2), payType: payType || 'hourly' };
    if (this.selectedRole.overtimeSelected) {
      data.overTime = overtime;
    }

    this.savingHourlyRate = true;
    await this.projectService.updateProjectRole(this.id || '', this.selectedRole._id, data);
    this.selectedRole.hourlyRateMin = this.selectedRole.offerSent ? hourlyRate : 0;
    this.selectedRole.hourlyRateSaved = hourlyRate;
    this.showHourSaveButton = false;
    this.savingHourlyRate = false;
    if (this.selectedRole.overtimeSelected) {
      this.selectedRole.overTimeMin = overtime;
      this.selectedRole.overTimeSaved = overtime;
    }
    await this.onInputChange();

  }

  async updateOvertime(overTime: number): Promise<void> {
    if (!this.selectedRole) {
      return;
    }
    if (this.selectedRole.overtimeSelected && !overTime) {
      this.toast.showError('Overtime should be greater than 0');
      return;
    }
    if (this.selectedRole.offerSent && (!this.selectedRole.overtimeSelected || overTime < this.selectedRole.overTimeSaved)) {
      this.toast.showError('Overtime cannot be reduced once offers are sent');
      return;
    }

    const data = { overTime: this.roundToHundredth(overTime) };

    await this.projectService.updateProjectRole(this.id || '', this.selectedRole._id, data);

    this.selectedRole.overTimeMin = this.selectedRole.offerSent ? overTime : this.selectedRole.overTimeMin;
    this.selectedRole.overTimeSaved = overTime;
    this.showOvertimeSaveButton = false;
    this.initialOvertime = this.roundToHundredth(overTime || 0);
    this.selectedRole.overTime = this.roundToHundredth(overTime || 0)
    await this.onInputChange();
  }

  onChangeHourlyRate(): void {
    this.showHourSaveButton = true;
  }

  searchReviewers(): void {
    if(!this.searchValue.length){
      this.showReviewerSearchError = false;
      this.getReviewersByProjectAndRoleId();
      return;
    }
    if(this.searchValue.length < 3){
      this.showReviewerSearchError = true;
      return;
    }
    this.showReviewerSearchError = false;
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce);
    }
    this.searchDebounce = setTimeout(() => {
      if(this.searchValue.length >= 3){
        this.getReviewersByProjectAndRoleId();
      }
    }, 1000);
  }

  roundToHundredth(num: any) {
    if (Number.isInteger(num)) {
      return num;
    }
    return Math.round(num * 100) / 100;
  }

  toggleOvertime(){
    if(this.selectedRole?.overtimeSelected){
      this.initialOvertime = Number(this.selectedRole?.hourlyRate)*1.5;
      this.selectedRole.overTime = this.roundToHundredth(Number(this.selectedRole?.hourlyRate)*1.5);
    } else {
      this.initialOvertime = 0;
    }
    this.onChangeOvertime();
  }

  ngOnDestroy(): void {
    // The three search debounces fire HTTP-backed loads. A timer that
    // outlives the component fires a stray request after navigation (and, in
    // tests, hits the destroyed injector with NG0205).
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce);
    }
    if (this.searchShortListedDebounce) {
      clearTimeout(this.searchShortListedDebounce);
    }
    if (this.searchOfferDebounce) {
      clearTimeout(this.searchOfferDebounce);
    }
  }

  onRemoveChip() {
    this.searchValue = '';
    this.getReviewersByProjectAndRoleId();
  }

  showMoreReviewers(){
    this.getReviewersByProjectAndRoleId(this.pagination.defaultReviewers, this.reviewers.length, 'showMoreReviewersList')
  }
  showMoreAutoGeneratedReviewers(){
    this.getAutoGeneratedReviewersByProjectAndRoleId(this.pagination.defaultReviewers, this.autogeneratedReviewers.length, 'showMoreReviewersList')
  }
  searchShortListedReviewers(): void {
    if (this.searchShortListedDebounce) {
      clearTimeout(this.searchShortListedDebounce);
    }
    this.searchShortListedDebounce = setTimeout(() => {
      this.initializeShortListedReviewer();
    }, 1000);
  }

  searchOfferReviewers(): void {
    if (this.searchOfferDebounce) {
      clearTimeout(this.searchOfferDebounce);
    }
    this.searchOfferDebounce = setTimeout(() => {
      this.initializeOfferQueueReviewers();
    }, 1000);
  }

  getProjectAndRoleId() {
    const params = {
      projectId: this.id,
      roleId: this.selectedRole?._id
    };
    return params;
  }

  async getReviewersByProjectAndRoleId(limit?:number, offset?:number, showMoreFlag?:string, type?:string): Promise<void> {
    
    offset = this.pagination.initialOffset;

    if(!showMoreFlag){
      limit = this.pagination.defaultReviewers;      
    }
    else{
      limit = this.reviewers.length + this.pagination.defaultReviewers;
    }

    const category = this.selectedFilter ?? null;
    this.updateColumns(category.key);
    this.category = category.key;

    // Build effective params by merging primary filter with all stacked filters
    const effectiveParams = this.buildEffectiveFilterParams(category);

    if(this.selectedSortOption[0].key == '' && this.selectedSortOrder){
      this.selectedSortOrder = false;
    }

    if (this.selectedRole?._id) {
      this.loadingReviewers = true;
      let data = await this.reviewerService.getReviewersByProjectId(
        this.id ?? '',
        this.selectedRole._id,
        limit,
        offset,
        this.selectedSortOption[0].key,
        effectiveParams.poolIds,
        effectiveParams.reviewerType,
        this.searchValue,
        effectiveParams.payRateType,
        effectiveParams.rankingType,
        effectiveParams.type,
        effectiveParams.min,
        effectiveParams.max,
        this.selectedSortOrder? constants.sortingOrder.ascending : constants.sortingOrder.descending,
        effectiveParams.days
      );
  
      this.reviewers = data.reviewers;

      this.lastPage = this.reviewers.length < limit;
      const reviewerCount = await this.reviewerService.getReviewersCount(this.id || '', [this.selectedRole?._id || ''], effectiveParams.poolIds, effectiveParams.reviewerType, this.searchValue, this.selectedSortOption[0].key);
      this.totalReviewersCount = reviewerCount && reviewerCount.length ? reviewerCount[0].reviewersCount : 0;
      this.loadingReviewers = false;
    } else {
      this.toast.showError('All roles have ended.');
    }
  };

  /**
   * Builds a single merged set of API params from the primary filter + all stacked filters.
   * reviewerType is sent as a comma-separated list of every active filter key so the backend
   * knows exactly which filters to apply, e.g. "workedTogetherReviewers,payRate,ranking".
   */
  buildEffectiveFilterParams(category: any): {
    reviewerType: string;
    poolIds: string[];
    payRateType: string;
    rankingType: string;
    type: string;
    min: number;
    max: number;
    days: number;
  } {
    // Start with the primary filter key (may be empty for "None")
    const activeKeys: string[] = category?.key ? [category.key] : [];

    let poolIds = [...this.selectedPoolIds];
    let type = this.selectedType;
    let payRateType = category?.key === constants.offerSenderFiltersKeys.PAY_RATE ? type : '';
    let rankingType = category?.key === constants.offerSenderFiltersKeys.RANKING ? type : '';
    let min = category?.key === constants.offerSenderFiltersKeys.PAY_RATE ? this.minPayRateValue : 0;
    let max = category?.key === constants.offerSenderFiltersKeys.PAY_RATE ? this.maxPayRateValue : 0;

    // Merge each stacked filter
    for (const [key, data] of this.stackedFilters.entries()) {
      activeKeys.push(key);

      if (key === constants.offerSenderFiltersKeys.TALENT_POOL && data.poolIds?.length) {
        poolIds = [...poolIds, ...data.poolIds];
      }
      if (key === constants.offerSenderFiltersKeys.PAY_RATE) {
        min = data.minVal ?? min;
        max = data.maxVal ?? max;
        payRateType = data.payRateType ?? payRateType;
      }
      if (key === constants.offerSenderFiltersKeys.RANKING && data.type) {
        rankingType = Array.isArray(data.type) ? data.type.join(',') : data.type;
      }
      if (key === constants.offerSenderFiltersKeys.LOCATION && data.type) {
        type = Array.isArray(data.type) ? data.type.join(',') : data.type;
      }
    }

    return {
      reviewerType: activeKeys.join(','),
      poolIds,
      payRateType,
      rankingType,
      type,
      min,
      max,
      days: activeKeys.includes(constants.offerSenderFiltersKeys.AVAILABLE_SOON) ? this.availableSoonDays : 0,
    };
  }

  async getAutoGeneratedReviewersByProjectAndRoleId(limit?:number, offset?:number, showMoreFlag?:string): Promise<void> {
    if(!showMoreFlag){
      this.autogeneratedReviewers.length = 0;
      limit = this.pagination.defaultReviewers;
      offset = this.pagination.initialOffset;
    }else{
      limit = this.pagination.defaultReviewers;
      offset = this.reviewers.length;
      
    }
    this.loadingReviewers = true;
    if (this.selectedRole?._id) {
      this.autogeneratedReviewers = this.autogeneratedReviewers.concat(
        (
          await this.reviewerService.getReviewersByProjectId(this.id ?? '', this.selectedRole?._id, limit, offset, '', [],'', '')
        ).reviewers
      );
      if(this.selectedShortlistedReviewers.length > 0){
      this.autogeneratedReviewers = this.autogeneratedReviewers.filter((autoRev)=>{
        return this.selectedShortlistedReviewers.some((shortRev)=>{
            return shortRev._id !== autoRev._id;
        });
      });    
      }
    } else {
      this.toast.showError('All roles have ended.');
    }
    this.loadingReviewers = false;
  }

  updateColumns(category: string) {
    const validCategory =
      category && Object.keys(this.columnConfigs).includes(category)
        ? category
        : null;

    this.removeConditionalColumns(validCategory || '');

    if (validCategory) {
      this.addConditionalColumns(this.columnConfigs[validCategory]);
    }

    this.updateColsArray();
  }

  removeConditionalColumns(category: string): void {
    const fieldsToRemove: string[] = [];
    if (this.cols.length > 5) {
      fieldsToRemove.push(
        ...(this.columnConfigs[this.category] || []).map((col) => col.field)
      );
    }

    this.cols = this.fixedCols
      .slice(0, 4)
      .concat(
        this.cols
          .slice(4, -1)
          .filter((col) => !fieldsToRemove.includes(col.field))
      )
      .concat(this.fixedCols.slice(-1));
  }

   addConditionalColumns(columnsToAdd: Column[]): void {
    const insertIndex = 4;

    columnsToAdd.forEach((col, index) => {
      if (!this.cols.some(existingCol => existingCol.field === col.field)) {
        this.cols.splice(insertIndex + index, 0, col);
      }
    });
  }

  updateColsArray(): void {
    if (this.cols[this.cols.length - 1]?.field !== 'actions') {
      this.cols.push(this.fixedCols.slice(-1)[0]);
    }
  }

  showMoreInfo($event: Event, details: any){

    const detail =  details.map((detail: any, index: number) => `${index + 1}. Firm Name: ${detail.firmName} -- Role Name: ${detail.roleName} <br>`).join('\n');
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message: detail,
      header: 'Reviewer Positions Details:',
      acceptVisible: false,
      rejectVisible: false 
      
    });
  }

  async getShortListedReviewersByProjectAndRoleId(limit = this.pagination.initialReviewers, offset = 0): Promise<void> {
    if (!this.selectedRole?._id) {
      this.toast.showError('All roles have ended.');
      return;
    }

    // Set loading state
    this.loadingShortlistedReviewers = true;

    try {
      const category = this.selectedFilter ?? null;
      const response = await this.reviewerService.getShortlistedReviewersByProjectId(
        this.id || '', 
        this.selectedRole._id, 
        limit, 
        offset, 
        this.selectedSortOption[0].key, 
        this.selectedPoolIds, 
        category?.key || '', 
        this.searchShortListed, 
        'shortlistedReviewers'
      );
      
      this.selectedShortlistedReviewers = this.selectedShortlistedReviewers.concat(response.reviewers);
      this.shortListedReviewersCount = response.count;
      this.getAutoGeneratedReviewersByProjectAndRoleId();
      
    } catch (error) {
      
      this.toast.showError('Error loading shortlisted reviewers');
    } finally {
      this.loadingShortlistedReviewers = false;
    }
  }

  // Update getOfferedQueueReviewers to include loading state
  async getOfferedQueueReviewers(limit = this.pagination.initialReviewers, offset = 0): Promise<void> {
    if (!this.selectedRole?._id) {
      this.toast.showError('All roles have ended.');
      return;
    }

    // Set loading state
    this.loadingOfferedQueueReviewers = true;

    try {
      const category = this.selectedFilter ?? null;
      const response = await this.reviewerService.getShortlistedReviewersByProjectId(
        this.id || '', 
        this.selectedRole._id, 
        limit, 
        offset, 
        this.selectedSortOption[0].key, 
        this.selectedPoolIds, 
        category?.key || '', 
        this.searchOfferValue, 
        'reviewers'
      );
      
      this.selectedOfferedQueueReviewers = this.selectedOfferedQueueReviewers.concat(response.reviewers);
      this.offersReviewersCount = response.count;
      
    } catch (error) {
      this.toast.showError('Error loading offered queue reviewers');
    } finally {
      this.loadingOfferedQueueReviewers = false;
    }
  }

  drop(event: CdkDragDrop<any[]>, from:string) {
    if(from === 'reviewers'){
      moveItemInArray(this.selectedShortlistedReviewers, event.previousIndex, event.currentIndex);
      this.updatePositionOfShortListedReviewers(event.currentIndex, this.selectedShortlistedReviewers[event.currentIndex]._id);  
    } else {
      moveItemInArray(this.autogeneratedReviewers, event.previousIndex, event.currentIndex);
    }
  }

  async onRemoveShortlistedReviewer(reviewer: any): Promise<void>{
    await this.projectService.removeShortListedReviewer(this.id || '', this.selectedRole?.id || '', reviewer._id);
    await this.initializeShortListedReviewer();
    this.selectedReviewers.length = 0;
    await this.getReviewersByProjectAndRoleId();
  }

  async onRemoveOfferedQueueReviewer(reviewer: any): Promise<void>{
    await this.projectService.removeOfferedQueueReviewer(this.id || '', this.selectedRole?.id || '', reviewer._id);
    await this.initializeOfferQueueReviewers();
    await this.initializeShortListedReviewer();
    this.selectedReviewers.length = 0;
    await this.getReviewersByProjectAndRoleId();
  }

  // Add helper methods to get counts for badges
  getShortlistedCount(): number {
    return this.loadingShortlistedReviewers ? 0 : this.selectedShortlistedReviewers.length;
  }

  getOfferedQueueCount(): number {
    return this.loadingOfferedQueueReviewers ? 0 : this.selectedOfferedQueueReviewers.length;
  }

  // Helper method to check if shortlisted tab should show spinner
  isShortlistedLoading(): boolean {
    return this.loadingShortlistedReviewers;
  }

  // Helper method to check if offered queue tab should show spinner
  isOfferedQueueLoading(): boolean {
    return this.loadingOfferedQueueReviewers;
  }

  openImmediateSendOfferModal(reviewer: any): void{
    if(!this.validateRoleDetails()){
      return;
    }
    this.sendOfferRef = this.dialogService.open(
      OfferConfirmationModalComponent,
      this.getOfferModalConfig('Send an offer to candidate immediately?', reviewer)
    );

    this.sendOfferRef.onClose.subscribe(async (offer: Offers) => {
      if (offer) {
        const payload = {
          ...offer
        };
        await this.offerService.createOffer(payload);
        this.onInputChange();

      }
    });
  }

  openImmediateOfferQueueSendOfferModal(event?: Event): void {
    this.confirmationDialogService.confirm({
      target: event?.target as EventTarget,
      message: 'This action will send offers to a maximum of 50 next users in the queue. Do you want to continue?',
      header: 'Confirm Action',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      accept: async () => {
        try {
          const payload = {
            roleId: this.selectedRole?._id,
            positionStarted: this.selectedRole?.isStarted ? new Date() : null
          };

          await this.offerService.createImmediateOffer(payload);
          this.toast.showSuccess('Offers has been sent to the reviewers');
          this.onInputChange();
        } catch (error: any) {
          this.toast.showError(error?.data?.message || 'Error sending offers');
        }
      }
    });
  }

  resumeOffers(): void{
    this.resumeOfferRef = this.dialogService.open(
      OfferConfirmationModalComponent,
      this.getModalConfig('Confirmation', 'Are you sure you want to resume the Offer Sender? Offers will resume sending at regular intervals.')
    );

    this.resumeOfferRef.onClose.subscribe(async (offer: Offers) => {
      if (offer) {
        const payload = {
          positionStarted: offer.positionStarted
        }
        await this.offerService.resumeOffers(this.id || '', this.selectedRole?._id || '', payload);
        this.disableResumeButton(true);
        this.onInputChange();

      }
    });
  }

  pauseOffers(): void {
    this.pauseOfferRef = this.dialogService.open(
      OfferConfirmationModalComponent,
      this.getModalConfig('Pause offer sender', 'Offers will not be sent until the offer sender is resumed. Are you sure you want to pause?')
    );

    this.pauseOfferRef.onClose.subscribe(async (offer: Offers) => {
      if (offer) {
        await this.offerService.pauseOffers(this.id || '', this.selectedRole?._id || '');
        this.disableResumeButton(false);
        this.onInputChange();
      }
    });
  }

  async openBulkSendOfferModal(): Promise<void>{
    // Use the same validation as single offer
    if(!this.validateRoleDetails()){
      return;
    }

    this.sendBulkOfferRef = this.dialogService.open(
      OfferConfirmationModalComponent,
      // Use the same modal config structure as single offers when role is started
      this.selectedRole?.isStarted ? 
        this.getOfferModalConfig('Send offers to shortlisted candidates') :
        this.getBulkOfferModalConfig('')
    );

    this.sendBulkOfferRef.onClose.subscribe(async (offer: Offers) => {
      if (offer) {
        const payload = {
          continueSendingOffers: this.selectedRole?.continueSendingOffers,
          positionStarted: this.selectedRole?.isStarted ? offer.positionStarted : null
        }
        const response = await this.offerService.sendOffers(this.id || '', this.selectedRole?._id || '', payload);
        if(!this.isUnPublishedProject) {
          this.toast.showSuccess(response?.data?.message || 'Selected reviewers are queued to receive offers');
        }
        await this.initializeShortListedReviewer();
        this.onInputChange();
        this.continueSendingOfferCheckBox = false;
        this.toggleContinueSendingOfferOnRole({ checked: false });
      } else {
        this.continueSendingOfferCheckBox = false;
        this.toggleContinueSendingOfferOnRole({ checked: false });
      }
    });
  }  

  updatePositionOfShortListedReviewers(rank: number, reviewerId: string): void{
    const payload = {
      rank,
      reviewerId
    }
    this.projectService.updateShortlistedPosition(this.id || '', this.selectedRole?._id || '', payload);
  }

  openSendOfferDialog(reviewer: Reviewer): void {
    if(!this.validateRoleDetails()){
      return;
    }
    this.sendOfferRef = this.dialogService.open(
      OfferConfirmationModalComponent,
      this.getOfferModalConfig('Send an offer to candidate immediately?', reviewer)
    );

    this.sendOfferRef.onClose.subscribe(async (offer: Offers) => {
      if (offer) {
        await this.offerService.createOffer(offer);
        this.onInputChange();
      }
    });
  }

  getOfferModalConfig(modalType: string, data?: any) {
    return {
      header: modalType,
      width:  this.selectedRole?.isStarted? '50vw' : '25vw',
      baseZIndex: 10000,
      contentStyle: { overflow: 'visible' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
      data: {
        ...data,
        roleId: this.selectedRole?._id,
        isStarted: this.selectedRole?.isStarted,
        buttonText: modalType,
        projectId: this.project?._id,
        selectedReviewers: this.selectedShortlistedReviewers.length,
      },
    };
  }

  getModalConfig(modalType: string, message?: string) {
    return {
      header: modalType,
      width: '35vw',
      baseZIndex: 10000,
      contentStyle: { overflow: 'visible' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
      data: {
        message: message || '',
        projectId: this.selectedRole?.project._id,
        roleId: this.selectedRole?._id,
        buttonText: modalType
      },
    };
  }

  getPayRateModalConfig() {
    return {
      header: `Set ${this.helperService.capitalizeFirstLetter(constants.roleRateType.PERSONAL.toLowerCase())} or ${this.helperService.capitalizeFirstLetter(constants.roleRateType.SPECIALTY.toLowerCase())} Rate`,
      width: '20vw',
      height: '25vh',
      baseZIndex: 10000,
      contentStyle: { overflow: 'visible' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
      data: {
        projectId: this.selectedRole?.project._id,
        roleId: this.selectedRole?._id,
        selectedType: this.selectedType,
        minPayRateValue: this.minPayRateValue,
        maxPayRateValue: this.maxPayRateValue
      },
    };
  }

  getMultiSelectModalConfig(modalType: string, filterKey?: string) {
    return {
      header: modalType,
      width: '30vw',
      height: '25vh',
      baseZIndex: 10000,
      contentStyle: { overflow: 'visible' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
      data: {
        projectId: this.selectedRole?.project._id,
        roleId: this.selectedRole?._id,
        key: filterKey || this.selectedFilter?.key,
        selectedType: this.selectedType,
      },
    };
  }

  getBulkOfferModalConfig(modalType: string) {
    const text =' and begin sending offers to all other candidates eligible for the role';
    return {
      header: this.isUnPublishedProject ? 'You have approved the selected team to receive offers after your project is published. Please click OK and proceed to the project review page, make sure everything is correct, and click Publish to get staffed up.' : 'Send offers',
      width: '30vw',
      baseZIndex: 10000,
      contentStyle: { overflow: 'visible' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
      data: {
        projectId: this.selectedRole?.project._id,
        roleId: this.selectedRole?._id,
        buttonText: modalType,
        selectedReviewers: this.selectedShortlistedReviewers.length,
        message: `You are about to send offers to shortlisted candidates${ this.continueSendingOfferCheckBox ? text: '' }. Are you sure?`
      },
    };
  }

  getTalentPoolModalConfig(modalType: string, isStacking = false) {
    return {
      header: modalType,
      width: '35vw',
      height: '600px',
      baseZIndex: 10000,
      contentStyle: { overflow: 'visible' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
      data: {
        talentPools: this.talentPools,
        onChangeTalentPool: (talentPoolIds: Array<string>) => {
          if (isStacking) {
            this.stackedFilters.set(constants.offerSenderFiltersKeys.TALENT_POOL, {
              name: 'Talent Pool',
              poolIds: talentPoolIds
            });
          } else {
            this.selectedPoolIds = talentPoolIds;
          }
          this.getReviewersByProjectAndRoleId();
        },
        buttonText: modalType,
      },
    };
  }

  isStackableFilter(key: string): boolean {
    return this.STACKABLE_FILTER_KEYS.has(key);
  }

  hasActiveFilter(): boolean {
    return !!this.selectedFilter && this.selectedFilter.key !== constants.offerSenderFiltersKeys.NONE;
  }

  canStackFilter(filterKey: string): boolean {
    return this.hasActiveFilter() && this.selectedFilter.key !== filterKey && this.isStackableFilter(filterKey);
  }

  isFilterStacked(key: string): boolean {
    return this.stackedFilters.has(key);
  }

  onAddStackedFilter(category: any, event: Event): void {
    event.stopPropagation();
    if (category.key === constants.offerSenderFiltersKeys.TALENT_POOL) {
      this.openTalentPoolSelectionModal(true);
    } else if (category.key === constants.offerSenderFiltersKeys.PAY_RATE) {
      this.openPayRateSelectorModal(true);
    } else if (category.key === constants.offerSenderFiltersKeys.RANKING) {
      this.openRankingSelectorModal(true);
    } else if (category.key === constants.offerSenderFiltersKeys.LOCATION) {
      this.openLocationSelectorModal(true);
    }
  }

  removeStackedFilter(key: string): void {
    this.stackedFilters.delete(key);
    this.getReviewersByProjectAndRoleId();
  }

  getStackedFilterLabel(entry: { key: string; name: string; poolIds?: string[]; minVal?: number; maxVal?: number; payRateType?: string; type?: any }): string {
    if (entry.key === constants.offerSenderFiltersKeys.PAY_RATE) {
      if(entry.payRateType === 'secondary'){
        entry.payRateType = constants.roleRateType.SPECIALTY.toLowerCase();
      }
      return `Pay Rate: ${this.helperService.capitalizeFirstLetter(entry.payRateType || '')} ($${entry.minVal} - $${entry.maxVal})`;
    }
    if (entry.key === constants.offerSenderFiltersKeys.TALENT_POOL) {
      return `Talent Pool (${entry.poolIds?.length || 0})`;
    }
    if (entry.key === constants.offerSenderFiltersKeys.RANKING || entry.key === constants.offerSenderFiltersKeys.LOCATION) {
      const types = Array.isArray(entry.type) ? entry.type.join(', ') : (entry.type || '');
      return types ? `${entry.name}: ${types}` : entry.name;
    }
    return entry.name;
  }

  onFilterChange(category: any) {
    // Selecting None clears everything
    if (!category.key) {
      this.stackedFilters.clear();
      this.selectedFilter = category;
      this.getReviewersByProjectAndRoleId();
      return;
    }
    // If selecting a stackable filter as the new primary, remove it from stacked (it's now primary)
    if (this.isStackableFilter(category.key)) {
      this.stackedFilters.delete(category.key);
    }
    this.selectedFilter = category;
    if (category.key === constants.offerSenderFiltersKeys.TALENT_POOL) {
      this.openTalentPoolSelectionModal();
      return;
    }
    if (category.key === constants.offerSenderFiltersKeys.PAY_RATE) {
      this.openPayRateSelectorModal();
      return;
    }
    if (category.key === constants.offerSenderFiltersKeys.RANKING) {
      this.openRankingSelectorModal();
      return;
    }
    if (category.key === constants.offerSenderFiltersKeys.LOCATION) {
      this.openLocationSelectorModal();
      return;
    }
    if (category.key === constants.offerSenderFiltersKeys.AVAILABLE_SOON) {
      this._pendingAvailableSoonCategory = category;
      this.showAvailableSoonModal = true;
      return;
    }
    this.getReviewerByFilter(category);
  }

  getReviewerByFilter(category: any){
    this.getReviewersByProjectAndRoleId();
  }

  applyAvailableSoonFilter(): void {
    this.showAvailableSoonModal = false;
    if (this._pendingAvailableSoonCategory) {
      this.selectedFilter = this._pendingAvailableSoonCategory;
      this._pendingAvailableSoonCategory = null;
    }
    this.getReviewersByProjectAndRoleId();
  }

  cancelAvailableSoonModal(): void {
    this.showAvailableSoonModal = false;
    this._pendingAvailableSoonCategory = null;
    if (this.selectedFilter?.key !== constants.offerSenderFiltersKeys.AVAILABLE_SOON) {
      this.resetFilter();
    }
  }

  toggleSortOrder(){
    this.selectedSortOrder = !this.selectedSortOrder;
    this.getReviewersByProjectAndRoleId();
  }

  onSortChange(sortOption: any) {
    this.selectedSortOption.length = 0;
    this.selectedSortOption.push(sortOption);
    this.getReviewersByProjectAndRoleId();
  }

  openTalentPoolSelectionModal(isStacking = false) {
    this.talentPoolRef = this.dialogService.open(
      TalentpoolModalComponent,
      this.getTalentPoolModalConfig('Select Talent Pool', isStacking)
    );

    this.talentPoolRef.onClose.subscribe({
      next: (data) => {
        if (!data || !data.talentPools) {
          if (!isStacking) {
            this.resetFilter();
          } else if (!this.stackedFilters.has(constants.offerSenderFiltersKeys.TALENT_POOL)) {
            this.getReviewersByProjectAndRoleId();
          }
        }
      }
    });
  }

  resetFilter() {
    this.selectedFilter = this.categories.find((e) => e.key === constants.offerSenderFiltersKeys.NONE);
    this.stackedFilters.clear();
    this.getReviewersByProjectAndRoleId();
  }
  openPayRateSelectorModal(isStacking = false) {
    this.payRateSelectorRef = this.dialogService.open(
      PayRateSelectorModalComponent, this.getPayRateModalConfig()
    );

    this.payRateSelectorRef.onClose.subscribe({
      next: (res) => {
        if (res && res.type && res.minValue !== undefined && res.maxValue !== undefined) {
          if (isStacking) {
            this.stackedFilters.set(constants.offerSenderFiltersKeys.PAY_RATE, {
              name: 'Pay Rate',
              minVal: res.minValue,
              maxVal: res.maxValue,
              payRateType: res.type
            });
            this.getReviewersByProjectAndRoleId();
          } else {
            this.selectedFilter = this.categories.find((e) => e.key === constants.offerSenderFiltersKeys.PAY_RATE);
            this.selectedType = res.type;
            this.minPayRateValue = res.minValue;
            this.maxPayRateValue = res.maxValue;
            this.getReviewersByProjectAndRoleId();
          }
        } else {
          if (!isStacking) {
            this.resetFilter();
          }
        }
      }
    });
  }

  openRankingSelectorModal(isStacking = false) {
    this.rankingSelectorRef = this.dialogService.open(
      MultiSelectSelectorModalComponent,
      this.getMultiSelectModalConfig('Select Ranking', constants.offerSenderFiltersKeys.RANKING)
    );

    this.rankingSelectorRef.onClose.subscribe({
      next: (res) => {
        if (res && res.type && res.type.length) {
          if (isStacking) {
            this.stackedFilters.set(constants.offerSenderFiltersKeys.RANKING, {
              name: 'Ranking',
              type: res.type
            });
            this.getReviewersByProjectAndRoleId();
          } else {
            this.selectedFilter = this.categories.find((e) => e.key === constants.offerSenderFiltersKeys.RANKING);
            this.selectedType = res.type;
            this.getReviewersByProjectAndRoleId();
          }
        } else {
          if (!isStacking) {
            this.resetFilter();
          }
        }
      }
    });
  }

  openLocationSelectorModal(isStacking = false) {
    this.locationSelectorRef = this.dialogService.open(
      MultiSelectSelectorModalComponent,
      this.getMultiSelectModalConfig('Select State', constants.offerSenderFiltersKeys.LOCATION)
    );

    this.locationSelectorRef.onClose.subscribe({
      next: (res) => {
        if (res && res.type && res.type.length) {
          if (isStacking) {
            this.stackedFilters.set(constants.offerSenderFiltersKeys.LOCATION, {
              name: 'Location',
              type: res.type
            });
            this.getReviewersByProjectAndRoleId();
          } else {
            this.selectedFilter = this.categories.find((e) => e.key === constants.offerSenderFiltersKeys.LOCATION);
            this.selectedType = res.type;
            this.getReviewersByProjectAndRoleId();
          }
        } else {
          if (!isStacking) {
            this.resetFilter();
          }
        }
      }
    });
  }

  goToPrevious(index: number): void {
    this.changeTab.emit(index);
  }

  gotoSentOfferScreen(index: number){
    this.activeTabIndex = index;
  }

  async updateRole(moveToNextTab: boolean = false): Promise<void> {

    if (this.validateRoleDetails() && this.selectedRole) {
      try {
        await this.projectService.updateProjectRole(this.id || '', this.selectedRole._id, {
          positions: this.selectedRole.positions,
          hourlyRate: this.selectedRole.hourlyRate,
          overTime: this.selectedRole.overTime
        });
  
        if (this.selectedReviewers.length) {
          this.moveToNextScreen(moveToNextTab);
        }
        else if (!moveToNextTab) {
          this.toast.showError(constants.select.error.noReviewerSelected);
        }
        else {
          this.moveToNextScreen(moveToNextTab);
        }
      } catch (error: any) {
        this.toast.showError(error?.data?.message || constants.select.error.updatingRole);
      }
    }
  }

  async moveToNextScreen(moveToNextTab: boolean = false): Promise<void>{
    await this.addToShortListedReviewers();
    if(moveToNextTab){
      await this.initializeShortListedReviewer();
      this.activeTabIndex = this.TAB_INDEXES.OFFERS_QUEUE;
    } else {
      this.getReviewersByProjectAndRoleId();
    }
    
  }

  async selectAndAddReviewerToShortList(reviewer: Reviewer){
    if(!this.validateRoleDetails()){
      return;
    }
    this.selectedReviewers.push(reviewer);
    await this.addToShortListedReviewers();
    await this.ngOnInit();
  }

  async addToShortListedReviewers(){
    await this.projectService.addShortListedReviewerForRole(this.id || '', this.selectedRole?._id || '', {
      reviewers: this.selectedReviewers.map(reviewer => reviewer._id)
    });
    this.selectedReviewers.length = 0;
  }

  validateRoleDetails () {
    if(!this.selectedRole){
      return false;
    }
    if ((this.selectedRole.positions <= this.selectedRole.occupiedPositions) && this.selectedReviewers.length) {
      this.toast.showError(constants.select.error.minimumDesiredFreelancer);
      return false;
    }
    if (this.selectedRole.positions == 0) {
      this.toast.showError(constants.select.error.minimumDesiredFreelancerCount);
      return false;
    }
    if (this.selectedRole.rateType === constants.roleRateType.UNIQUE && this.selectedRole?.hourlyRateSaved <= 0) {
      this.toast.showError(constants.select.error.minimumHourlyRate);
      return false;
    }
    return true;
  }

  async fetchOfferQueueLogs() {
    if (!this.selectedRole?._id) return;
    this.loadingOfferQueueLogs = true;
    try {
      // Replace with your actual service/method to fetch offerSenderBatch by role id
      const batches = await this.offerService.getOfferSenderBatchByRoleId(this.id || '',   this.selectedRole._id);
      this.offerQueueLogs = [];
      for (const batch of batches) {
        for (const entry of batch.reviewers) {
          this.offerQueueLogs.push({
            reviewer: entry.reviewer,
            offerSentAt: entry.offerSentAt ? new Date(entry.offerSentAt).toLocaleString() : 'N/A',
            status: entry.offerSent === true ? 'Sent' : entry.error ? 'Errored' : 'Pending',
            error: entry.error // Make sure your API returns error text if any
          });
        }
      }
    } catch (e) {
      this.toast.showError('Failed to fetch offer queue logs');
    }
    this.loadingOfferQueueLogs = false;
  }

  // Update tab change handler to fetch logs when tab is selected
  async onReviewerTabChange(e: any): Promise<void> {
    this.activeTabIndex = e.index;
    
    // Reset offer queue tab index when switching main tabs
    if (e.index === this.TAB_INDEXES.OFFERS_QUEUE) {
      this.offerQueueActiveTabIndex = this.OFFER_QUEUE_TAB_INDEXES.OFFER_QUEUED_LIST; // Always start with first tab when entering OFFERS QUEUE
    }
    
    switch (this.activeTabIndex) {
      case this.TAB_INDEXES.SELECT_CANDIDATES:
        this.getReviewersByProjectAndRoleId();
        break;
      case this.TAB_INDEXES.OFFERS_QUEUE:
        this.onInputChange();
        break;
      case this.TAB_INDEXES.OFFER_QUEUE_LOGS:     
        this.fetchOfferQueueLogs(); 
        break;
      default:
        break;
    }
  }

  // Update initializeShortListedReviewer to clear loading state
  async initializeShortListedReviewer(): Promise<void> {
    this.selectedShortlistedReviewers.length = 0;
    await this.getShortListedReviewersByProjectAndRoleId();
  }

  // Update initializeOfferQueueReviewers to clear loading state
  async initializeOfferQueueReviewers(): Promise<void> {
    this.selectedOfferedQueueReviewers.length = 0;
    await this.getOfferedQueueReviewers();
  }

  onOfferQueueTabChange(event: any): void {
    this.offerQueueActiveTabIndex = event.index;
    
    // Handle logic based on which tab is selected
    if (event.index === this.OFFER_QUEUE_TAB_INDEXES.SHORTLISTED_CANDIDATES) {
      // Refresh shortlisted candidates if needed
        this.initializeShortListedReviewer();
    } else if (event.index === this.OFFER_QUEUE_TAB_INDEXES.OFFER_QUEUED_LIST) {
      // Refresh offered queue reviewers if needed
        this.initializeOfferQueueReviewers();
    
      }
  }

  async getRoleByProjectAndRoleID(): Promise<void>{
    if(!this.selectedRole){
      return;
    }
    this.updatedRole = await this.rolesService.getRoleByProjectAndRoleId(this.id || '', this.selectedRole?._id || '');
    this.selectedRole.offersQueueId = this.updatedRole?.offersQueueId;
  }

  disableResumeButton(isQueueRunning: boolean): void{
    if(!this.selectedRole || !this.updatedRole){
      return;
    }
    this.selectedRole.offersQueueId = isQueueRunning;
    this.updatedRole.offersQueueId = isQueueRunning;
    this.showResumeButton = !isQueueRunning; 
  }

  initializeResumeButton(): void{
    this.showResumeButton = !!(this.offersReviewersCount && !this.updatedRole?.offersQueueId &&
      (this.project?.status === constants.roleStatus.published ||
          this.project?.status === constants.roleStatus.started) &&
      ((this.updatedRole?.occupiedPositions || 0) < (this.updatedRole?.positions || 0)));
  }

  openReviewerDialog(id:string){
    this.reviewerDetailDialogService.openDialog(id);
  }

  selectRoleForOffer(role: any){
    this.selectedRole = this.roles.find((r:any) => r._id === role._id) || null;    
  }

  viewScreeningQuestions(details: any): void {
    this.confirmationDialogService.confirm({
      message: details,
      header: 'Screening Questions',
      acceptLabel: 'OK',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectVisible: false,
      accept: () => {}
    });
  }
}
